var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#F7931A",
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.524 6.86c.16-1.065-.651-1.637-1.76-2.019l.36-1.442-.878-.218-.35 1.404a36.7 36.7 0 0 0-.703-.166l.353-1.413-.878-.219-.36 1.442a29.364 29.364 0 0 1-.56-.132l.001-.005-1.21-.302-.234.938s.651.149.638.158c.355.089.42.324.409.51l-.41 1.643a.727.727 0 0 1 .091.03l-.092-.023-.574 2.3c-.044.109-.154.27-.403.21.01.012-.638-.16-.638-.16l-.435 1.005 1.142.284c.212.054.42.11.626.162l-.364 1.459.877.218.36-1.443c.24.065.472.125.7.182l-.36 1.436.879.219.363-1.456c1.497.283 2.622.169 3.096-1.185.381-1.09-.02-1.718-.807-2.128.574-.133 1.006-.51 1.121-1.29ZM9.519 9.672c-.272 1.09-2.107.5-2.702.353L7.3 8.093c.595.148 2.503.442 2.22 1.579Zm.271-2.828c-.247.992-1.775.488-2.27.364l.437-1.752c.495.123 2.09.354 1.833 1.388Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtc);
export default __webpack_public_path__ + "static/media/btc.97a2583d1c43190d7ef628d636677c7e.svg";
export { ForwardRef as ReactComponent };